import styled from "styled-components";

const Wrap = styled.div`
  background: #C8271B;
  padding: 32px 0 12px;
  h2 {
    color: #ffffff;
    font-weight: 700;
  }
`

export const Wrap1 = styled.div`
  padding: 32px 0;
  background: linear-gradient(to top,#fff,#fff);
`

export default Wrap